type EnvironmentType =
  | "Local"
  | "QA"
  | "Staging"
  | "LocalProd"
  | "Prod";

interface EnvironmentVariables {
  urlMatch?: string; // used to determine environment
  clientId: string;
  apiBaseUrl?: string;
  showWarning?: boolean;
  showConversionRuleEditor?: boolean;
  showClassification?: boolean;
  authority: string;
  identityUrl?: string;
  scope?: string;
  response_type?: string;
}

type EnvironmentVariablesMap = {
  [key in string]: EnvironmentVariables;
};

// const devApiUrl = "https://api-euc1.trimblepaas.com/quadri-configuration-qa-v2.0";
// const prodApiUrl = "https://api-euc1.trimblepaas.com/quadri-configuration-v2.0";
const devApiUrl = "https://cloud.qa.api.trimblecloud.com/construction-management/quadri-configuration-qa/2.0";
// const devApiUrl = "https://localhost:44310"
const stagingApiUrl = "https://cloud.api.trimble.com/Construction-Management/quadri-configuration-stg/2.0";
const prodApiUrl = "https://cloud.api.trimble.com/Construction-Management/quadri-configuration/2.0";
const prodAuthority = "https://id.trimble.com";
const prodTrimbleIdentityUrl = "https://myprofile.trimble.com";
const stagingQaAuthority = "https://stage.id.trimblecloud.com";
const stagingTrimbleIdentityUrl = "https://stage.myprofile.trimblecloud.com";

const Environments: EnvironmentVariablesMap = {
  Local: {
    clientId: "5b5f7ff9-892f-4c50-879a-c737531f4a62",
    scope: "openid quadri-community-SPA-LOCALHOST",
    response_type: "code",
    urlMatch: "localhost",
    apiBaseUrl: devApiUrl,
    authority: stagingQaAuthority,
    identityUrl: stagingTrimbleIdentityUrl,
    showWarning: true,
    showConversionRuleEditor: true
  },
  QA: {
    clientId: "6cbd29e4-0703-4887-9b8d-f3e11fd6755b",
    scope: "openid quadri-community-SPA-QA",
    response_type: "code",
    urlMatch: "quadricommunitywebqa",
    apiBaseUrl: devApiUrl,
    authority: stagingQaAuthority,
    identityUrl: stagingTrimbleIdentityUrl,
    showWarning: true,
    showConversionRuleEditor: true
  },
  Staging: {
    clientId: "09a90c95-67fb-443f-8d74-aed9611a0297",
    scope: "openid quadri-community-SPA-STG",
    response_type: "code",
    urlMatch: "quadricommunitywebstg",
    apiBaseUrl: stagingApiUrl,
    authority: prodAuthority,
    identityUrl: prodTrimbleIdentityUrl,
    showWarning: true,
  },
  LocalProd: {
    clientId: "977d07cb-2a0c-4ad5-8d2b-af30b4b1270b",
    apiBaseUrl: prodApiUrl,
    authority: prodAuthority,
    identityUrl: prodTrimbleIdentityUrl,
  },
  Prod: {
    clientId: "0231e90c-8370-460a-972f-8613e38f5f5c",
    scope: "openid quadri-community-SPA-PROD",
    response_type: "code",
    urlMatch: "configuration.quadri.trimble.com",
    apiBaseUrl: prodApiUrl,
    authority: prodAuthority,
    identityUrl: prodTrimbleIdentityUrl,
  },
};

const getEnvironment = (
  specifyEnvironment?: EnvironmentType
): EnvironmentVariables => {
  if (specifyEnvironment && Environments[specifyEnvironment]) {
    const environment = Environments[specifyEnvironment]
    console.log("Using specified environment")
    return environment;
  } else {
    const environmentMatch = Object.keys(Environments)
      .map((k) => Environments[k] as EnvironmentVariables)
      .find(
        (env) => env.urlMatch && window.location.origin.includes(env.urlMatch)
      );
    
    if (environmentMatch) {
      console.log("Using environment url match")
      return environmentMatch
    } else {
      console.log("No environment url match found, defaulting to prod environment")
      return Environments.Prod
    }
  }
};

// If environment needs to be overridden and not detected, do it here
// const Environment = getEnvironment("LocalProd");
const Environment = getEnvironment();

console.log("environment = ", Environment);

export default Environment;
